import styled from 'styled-components';
import Slick, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BrandSitesV2Theme } from '../common/GlobalStyle';

export default function GiftCardSection() {
  const slickSettings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '25%',
    arrows: false,
    touchThreshold: 20,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          centerPadding: '0',
        },
      },
    ],
  };

  return (
    <Container>
      <OuterWrapper>
        <InnerWrapper>
          <TitleWrapper>
            <FakeTitle>언제나 좋은, 때가 없는 청소 선물</FakeTitle>
            <TitleDesktop>{TitleDesktopSvg}</TitleDesktop>
            <TitleTablet>{TitleTabletSvg}</TitleTablet>
            <TitleMobile>{TitleMobileSvg}</TitleMobile>
          </TitleWrapper>
        </InnerWrapper>
        <SlickContainer>
          <Slick {...slickSettings}>
            <SlickItem>
              <Card>
                <picture>
                  <source
                    type="image/webp"
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/webp/giftcard1.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/giftcard1.png"
                  />
                  <CardImage
                    alt=""
                    src="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/giftcard1.png"
                  />
                </picture>
                <CardText>
                  따로 살아보니 집청소가 너무 귀찮고 힘들었는데, 청소연구소가 너무 편해 부모님 생각이나서 조금이라도
                  편히 쉬시길 바라며 선물했어요.
                </CardText>
                <CardSub>
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/webp/jaebyeong.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/jaebyeong.png"
                    />
                    <CardAvatar
                      alt=""
                      src="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/jaebyeong.png"
                    />
                  </picture>
                  <CardWho>
                    부모님댁에 선물하신 <CardWhoHighlight>재병님</CardWhoHighlight>
                  </CardWho>
                </CardSub>
              </Card>
            </SlickItem>
            <SlickItem>
              <Card>
                <picture>
                  <source
                    type="image/webp"
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/webp/giftcard2.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/giftcard2.png"
                  />
                  <CardImage
                    alt=""
                    src="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/giftcard2.png"
                  />
                </picture>
                <CardText>
                  아기가 태어난뒤 두 배 바빠진 오빠 집안일에 귀여운 조카 생각이나서 집청소를 선물했어요. 잠깐
                  몇시간이라도 여유가 생겼으면 좋겠어요.
                </CardText>
                <CardSub>
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/webp/mijeong.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/mijeong.png"
                    />
                    <CardAvatar
                      alt=""
                      src="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/mijeong.png"
                    />
                  </picture>
                  <CardWho>
                    친오빠집에 선물하신 <CardWhoHighlight>미정님</CardWhoHighlight>
                  </CardWho>
                </CardSub>
              </Card>
            </SlickItem>
            <SlickItem>
              <Card>
                <picture>
                  <source
                    type="image/webp"
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/webp/giftcard3.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/giftcard3.png"
                  />
                  <CardImage
                    alt=""
                    src="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/giftcard3.png"
                  />
                </picture>
                <CardText>
                  남들 다 주는 선물말고 특별한 선물로 선택했어요. 동료가 퇴근 후 깨끗한 집에서 멋진 생일을 보낼 것을
                  생각하니 벌써 기분이 좋습니다.
                </CardText>
                <CardSub>
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/webp/jihyun.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/jihyun.png"
                    />
                    <CardAvatar
                      alt=""
                      src="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/jihyun.png"
                    />
                  </picture>
                  <CardWho>
                    직장동료에게 선물하신 <CardWhoHighlight>지현님</CardWhoHighlight>
                  </CardWho>
                </CardSub>
              </Card>
            </SlickItem>
            <SlickItem>
              <Card>
                <picture>
                  <source
                    type="image/webp"
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/webp/giftcard4.webp"
                  />
                  <source
                    type="image/png"
                    srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/giftcard4.png"
                  />
                  <CardImage
                    alt=""
                    src="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/giftcard4.png"
                  />
                </picture>
                <CardText>
                  내 집 마련에 성공한 동생에게 선물했어요. 깨끗하게 들어간 집 계속 잘 관리받으며 쾌적하게 살았으면
                  좋겠어요!
                </CardText>
                <CardSub>
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/webp/sanghyun.webp"
                    />
                    <source
                      type="image/png"
                      srcSet="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/sanghyun.png"
                    />
                    <CardAvatar
                      alt=""
                      src="https://cleanhome-web.cleaninglab.co.kr/brandsite/gift/sanghyun.png"
                    />
                  </picture>
                  <CardWho>
                    동생에게 선물하신 <CardWhoHighlight>상현님</CardWhoHighlight>
                  </CardWho>
                </CardSub>
              </Card>
            </SlickItem>
          </Slick>
        </SlickContainer>
      </OuterWrapper>
    </Container>
  );
}

const Container = styled.section`
  width: 100%;
`;

const OuterWrapper = styled.div`
  position: relative;
  padding-top: 134px;
  padding-bottom: 110px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    padding-top: 84px;
    padding-bottom: 90px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    padding: 0 24px;
    padding-top: 64px;
    padding-bottom: 57px;
  }
`;

const InnerWrapper = styled.div`
  margin: 0 auto;
  max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.desktop};

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    max-width: ${({ theme }) => theme.brandSitesV2!.containerWidths!.tablet};
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  margin-bottom: 16px;
  justify-content: center;
  margin-bottom: 110px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    margin-bottom: 50px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 44px;
  }
`;

const FakeTitle = styled.h1`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  text-indent: -5000px;
`;

const TitleDesktop = styled.div`
  display: block;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: none;
  }
`;

const TitleTablet = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    display: block;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    display: none;
  }
`;

const TitleMobile = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    display: block;
  }
`;

const SlickContainer = styled.div`
  width: 100%;

  .slick-slider {
    width: 1px;
    min-width: 100%;
  }

  .slick-dots li {
    margin: 0 2px;

    /* & button:not(:focus):hover::before {
      opacity: #cccccc;
    } */

    &:nth-child(1).slick-active button::before {
      color: #ffe088;
    }
    &:nth-child(2).slick-active button::before {
      color: #5ecbdd;
    }
    &:nth-child(3).slick-active button::before {
      color: #cc99cc;
    }
    &:nth-child(4).slick-active button::before {
      color: #ec6940;
    }

    & button::before {
      font-size: 12px !important;
      color: #e5e5e5;
      opacity: 1;
    }
  }

  .slick-slide div {
    outline: none;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    .slick-dots li {
      margin: 0;

      & button::before {
        font-size: 10px !important;
      }
    }
  }
`;

const SlickItem = styled.div`
  cursor: pointer;
  overflow: hidden;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 80px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    margin-bottom: 10px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    margin-bottom: 30px;
  }
`;

const CardImage = styled.img`
  display: block;
  margin-bottom: 60px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    width: 408px;
    margin-bottom: 50px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    width: 242px;
    margin-bottom: 28px;
  }
`;

const CardText = styled.p`
  width: 500px;
  font-weight: 300;
  font-size: 24px;
  line-height: 152%;
  text-align: center;
  letter-spacing: -1px;
  word-break: keep-all;
  margin-bottom: 40px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 20px;
    width: 380px;
    margin-bottom: 28px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 16px;
    width: 240px;
    margin-bottom: 24px;
    font-weight: 400;
  }
`;

const CardSub = styled.div`
  display: flex;
  align-items: center;
`;

const CardAvatar = styled.img`
  display: block;
  margin-right: 12px;

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    width: 22px;
    height: 22px;
    margin-right: 6px;
  }
`;

const CardWho = styled.p`
  font-weight: 400;
  font-size: 24px;
  line-height: 140%;
  color: rgba(0, 0, 0, 0.6);

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.tablet}) {
    font-size: 20px;
  }

  @media (max-width: ${({ theme }) => theme.brandSitesV2!.breakpoints.mobile}) {
    font-size: 16px;
  }
`;

const CardWhoHighlight = styled.span`
  font-weight: 600;
`;

const TitleDesktopSvg = (
  <svg width="606" height="46" viewBox="0 0 606 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.8282 13.4906C5.8282 10.1786 8.2202 7.7866 11.3942 7.7866C14.6602 7.7866 17.1902 10.1786 17.1902 13.4906C17.1902 16.8026 14.6602 19.2866 11.3942 19.2866C8.2202 19.2866 5.8282 16.8026 5.8282 13.4906ZM35.4982 42.5166V37.6866H15.4422V27.4286H9.7382V42.5166H35.4982ZM0.262196 13.5366C0.262196 19.5166 4.9082 24.0706 11.3942 24.0706C17.1902 24.0706 21.5602 20.5746 22.5262 15.6986H29.3802V30.6026H34.9922V0.7026H29.3802V10.9606H22.4342C21.2842 6.3146 17.0062 2.9106 11.3942 2.9106C4.9082 2.9106 0.262196 7.6026 0.262196 13.5366ZM71.3746 38.6986H76.8946V0.7026H71.3746V38.6986ZM68.3846 37.1346V1.2546H63.0026V12.2026H57.5746V16.8486H63.0026V37.1346H68.3846ZM59.8746 7.8326V3.1406H40.6466V7.8326H47.5006C47.4086 17.9986 44.1426 22.0926 39.4506 25.5886L42.8086 29.6366C45.9826 27.6586 49.4326 23.3346 50.4446 19.5166C51.5026 22.9666 55.5046 27.2446 58.1726 28.8086L61.3926 24.5306C56.7926 21.9546 53.2966 17.6766 53.1586 7.8326H59.8746ZM121.649 17.6306V12.9386H114.795V0.7026H109.183V38.6526H114.795V17.6306H121.649ZM105.963 21.1726C100.489 22.0926 94.647 22.7826 88.713 22.6446V2.9106H83.101V27.3826C92.485 27.3826 100.075 26.9226 106.423 25.6346L105.963 21.1726ZM158.458 37.7786C158.458 39.4806 156.94 40.8606 154.226 40.8606C151.512 40.8606 149.81 39.4806 149.81 37.7786C149.81 36.5366 151.512 34.9726 154.226 34.9726C156.94 34.9726 158.458 36.4906 158.458 37.7786ZM160.344 28.5786V24.3006H147.878V28.5786H160.344ZM173.454 22.6446V18.1826H157.124V14.0426H151.466V18.1826H135.09V22.6446H173.454ZM167.658 5.9006V1.3926H140.84V5.9006H150.362C148.982 9.3506 144.428 11.2366 139.184 11.9726L141.346 16.3426C146.958 15.6526 152.386 13.1686 154.272 9.3506C156.388 13.1226 161.678 15.4226 167.244 16.2506L169.406 11.9266C164.484 11.1906 159.7 9.3506 158.182 5.9006H167.658ZM163.794 38.1006C163.794 36.8126 163.242 35.6166 162.276 34.5586H168.256V30.1886H140.288V34.5586H146.13C145.118 35.6166 144.566 36.8126 144.566 38.1006C144.566 42.0106 148.614 44.9086 154.272 44.9086C159.792 44.9086 163.794 42.0106 163.794 38.1006ZM202.292 10.5466C202.292 13.6286 199.486 15.7906 195.668 15.7906C191.712 15.7906 189.044 13.6286 189.044 10.5466C189.044 7.5566 191.758 5.3486 195.668 5.3486C199.486 5.3486 202.292 7.5566 202.292 10.5466ZM207.812 10.5466C207.812 4.4746 202.43 0.564599 195.668 0.564599C189.09 0.564599 183.524 4.4286 183.524 10.5466C183.524 17.2626 189.504 20.5286 195.668 20.5286C201.786 20.5286 207.812 17.2166 207.812 10.5466ZM214.85 27.0606V22.3226H176.486V27.0606H214.85ZM182.834 29.3606V42.9306H209.192V38.2386H188.492V29.3606H182.834ZM218.803 38.1466H221.839C221.839 40.0326 220.459 42.0566 218.113 42.5166L218.849 45.2306C222.943 44.3566 225.427 40.8606 225.427 36.8126V31.9366H218.803V38.1466ZM250.714 22.0926C249.426 22.4146 247.54 22.5526 246.528 22.5066V8.0166H250.438V3.4166H241.192V27.1986C244.044 27.4286 248.782 27.1526 251.036 26.7386L250.714 22.0926ZM262.95 22.3686C261.938 22.6446 259.638 22.9666 257.936 22.8286V8.0166H262.398V3.4166H252.646V27.4746C255.36 27.7046 260.696 27.6126 263.41 26.7846L262.95 22.3686ZM278.82 38.6066V0.7026H273.484V12.5706H270.31V1.2546H265.066V37.0426H270.31V17.3086H273.484V38.6066H278.82ZM284.888 3.3246V8.1086H298.826C298.182 14.7786 292.754 21.7706 282.91 25.4046L285.992 30.0046C298.596 24.8066 304.76 15.6986 304.714 3.3246H284.888ZM322.838 17.5386V12.8466H316.076V0.7026H310.372V38.6526H316.076V17.5386H322.838ZM352.379 38.8826H348.055V34.8806H352.379V38.8826ZM343.087 12.0646C343.087 8.8906 345.433 6.6826 348.561 6.6826C351.689 6.6826 354.081 8.8906 354.081 12.0646C354.081 15.2846 351.689 17.4926 348.561 17.4926C345.433 17.4926 343.087 15.2846 343.087 12.0646ZM357.669 43.4826V40.9986L360.107 44.0806C363.235 42.5166 365.765 39.5726 366.915 36.6286C367.973 39.5266 370.917 42.7006 373.539 43.8506L376.621 39.8026C371.883 37.5486 369.721 33.0866 369.721 28.4406V25.5426H364.155V28.7626C364.155 33.3626 361.763 37.3646 357.669 39.4806V25.6346H352.379V30.3266H348.055V25.6346H342.765V43.4826H357.669ZM337.567 12.1106C337.567 17.8606 342.121 22.3226 348.561 22.3226C354.219 22.3226 358.451 18.8726 359.371 14.0886H366.639V23.4266H372.297V0.6566H366.639V9.3966H359.187C357.991 5.0266 353.943 1.8986 348.561 1.8986C342.121 1.8986 337.567 6.4066 337.567 12.1106ZM416.039 25.3586V20.5746H377.675V25.3586H416.039ZM384.069 1.0706V16.6186H410.243V11.8806H389.727V1.0706H384.069ZM383.839 28.5326V42.6086H410.197V37.8706H389.497V28.5326H383.839ZM450.64 5.3946V0.6566H437.392V5.3946H450.64ZM461.128 35.3866C461.128 38.1006 458.598 39.8026 455.24 39.8026C451.79 39.8026 449.398 38.1006 449.398 35.3866C449.398 32.7186 451.79 31.0166 455.24 31.0166C458.598 31.0166 461.128 32.7186 461.128 35.3866ZM467.062 26.1866V0.610601H461.45V13.5366H454.872V18.1366H461.45V26.1866H467.062ZM455.24 12.3866V7.6486H432.746V12.3866H440.934C440.244 17.3086 436.058 20.3446 431.55 21.7246L434.08 26.1866C438.588 24.8066 442.774 21.2646 444.154 18.1366C445.58 21.2186 450.272 24.3926 454.136 25.3126L456.528 20.7586C451.744 19.5626 447.972 17.0786 447.328 12.3866H455.24ZM466.694 35.3866C466.694 30.0966 461.864 26.3246 455.24 26.3246C448.616 26.3246 443.786 30.0966 443.786 35.3866C443.786 40.8606 448.616 44.4946 455.24 44.4946C461.864 44.4946 466.694 40.8606 466.694 35.3866ZM510.805 34.7426V30.0506H494.475V21.3566H488.817V30.0506H472.441V34.7426H510.805ZM488.357 1.7146V4.2446C488.357 11.6966 482.055 16.3886 475.247 18.2286L477.777 23.0586C484.079 21.1266 489.277 17.4006 491.623 12.3866C494.107 17.2166 499.029 20.9426 505.515 22.9666L508.045 18.1826C501.329 16.2506 494.889 11.6966 494.889 4.2446V1.7146H488.357ZM551.064 21.1726C546.188 19.4706 541.496 13.6286 541.496 7.4186V2.2666H535.562V7.5106C535.562 14.0886 531.284 19.8386 525.764 22.4606L529.076 26.6466C533.492 24.5766 537.08 20.1146 538.644 16.2966C540.392 19.9766 544.302 23.8866 548.12 25.4506L551.064 21.1726ZM562.656 42.5166V37.6866H542.738V27.4286H537.172V42.5166H562.656ZM561.828 30.5566V0.7026H556.216V9.5806H548.166V14.3186H556.216V30.5566H561.828ZM593.564 11.1446H579.212V5.3946H593.564V11.1446ZM599.222 15.7906V0.794599H573.554V15.7906H599.222ZM600.28 44.1726V39.6646H578.89V37.3186H599.176V26.1406H589.24V23.1046H605.57V18.4586H567.206V23.1046H583.582V26.1406H573.324V30.6946H593.61V32.9026H573.324V44.1726H600.28Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

const TitleTabletSvg = (
  <svg width="366" height="27" viewBox="0 0 366 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.86 8.257C3.86 6.205 5.345 4.693 7.424 4.693C9.503 4.693 11.069 6.205 11.069 8.257C11.069 10.282 9.503 11.875 7.424 11.875C5.345 11.875 3.86 10.282 3.86 8.257ZM21.68 25.483V22.891H9.53V16.654H6.533V25.483H21.68ZM0.89 8.257C0.89 11.821 3.644 14.467 7.424 14.467C10.34 14.467 12.608 12.982 13.553 10.741C13.742 10.336 13.877 9.877 13.958 9.418H18.359V18.436H21.383V0.696999H18.359V6.907H13.904C13.823 6.556 13.715 6.178 13.553 5.827C12.581 3.559 10.34 2.047 7.424 2.047C3.644 2.047 0.89 4.774 0.89 8.257ZM43.5479 23.242H46.5179V0.723999H43.5479V23.242ZM41.5229 22.378V1.048H38.6069V7.636H35.1239V10.147H38.6069V22.378H41.5229ZM29.3189 4.774V4.855C29.3189 11.092 27.2939 13.522 24.4589 15.709L26.2679 17.842C28.2389 16.492 30.2369 14.035 30.8849 11.713C31.5599 13.846 33.7469 16.384 35.5559 17.356L37.3109 15.061C34.4759 13.36 32.3699 10.822 32.3699 4.801V4.774H36.4469V2.209H25.0799V4.774H29.3189ZM64.2818 12.955C61.0418 13.576 57.5318 13.981 53.6708 13.9V2.047H50.6468V16.438C56.3438 16.438 60.7718 16.168 64.5518 15.385L64.2818 12.955ZM73.3808 10.633V8.068H69.2768V0.723999H66.2528V23.215H69.2768V10.633H73.3808ZM96.2821 22.702C96.2821 23.809 95.2021 24.727 93.4741 24.727C91.7461 24.727 90.6121 23.809 90.6121 22.702C90.6121 21.865 91.7461 20.947 93.4741 20.947C95.2021 20.947 96.2821 21.865 96.2821 22.702ZM97.0921 17.113V14.764H89.7211V17.113H97.0921ZM104.868 13.603V11.173H94.9861V8.743H92.0431V11.173H82.1341V13.603H104.868ZM91.5031 3.613C91.4221 3.91 91.2871 4.207 91.1251 4.45C89.9641 6.178 87.5341 7.096 84.5911 7.582L85.7521 9.904C89.1541 9.472 92.3671 7.96 93.5011 5.719C94.6891 7.933 97.8751 9.391 101.25 9.877L102.411 7.555C99.5761 7.123 97.1191 6.151 95.9041 4.45C95.7151 4.207 95.5801 3.91 95.4721 3.613H101.412V1.129H85.5361V3.613H91.5031ZM99.1171 22.864C99.1171 22.351 98.9821 21.838 98.7121 21.379C98.5501 21.109 98.3341 20.839 98.0911 20.596H101.763V18.22H85.2121V20.596H88.8841C88.6141 20.839 88.3981 21.109 88.2091 21.406C87.9121 21.865 87.7771 22.351 87.7771 22.864C87.7771 25.132 90.1531 26.887 93.5011 26.887C96.7951 26.887 99.1171 25.132 99.1171 22.864ZM122.389 6.313C122.389 8.23 120.742 9.445 118.339 9.445C115.855 9.445 114.289 8.23 114.289 6.313C114.289 4.612 115.936 3.181 118.339 3.181C120.688 3.181 122.389 4.612 122.389 6.313ZM125.413 6.313C125.413 2.911 122.281 0.696999 118.339 0.696999C114.586 0.696999 111.265 2.857 111.265 6.313C111.265 10.12 114.721 11.983 118.339 11.983C121.876 11.983 125.413 10.12 125.413 6.313ZM129.706 15.898V13.333H106.972V15.898H129.706ZM110.806 17.842V25.726H126.331V23.215H113.776V17.842H110.806ZM132.485 22.756H134.132C134.132 23.89 133.376 24.997 132.08 25.294L132.458 26.698C134.645 26.212 135.968 24.295 135.968 22.189V19.462H132.485V22.756ZM151.951 13.576C151.087 13.765 149.953 13.819 149.197 13.819V4.882H151.735V2.344H146.308V16.357C148.117 16.438 150.682 16.33 152.167 16.06L151.951 13.576ZM159.322 13.657C158.566 13.873 156.946 14.035 155.974 13.954V4.882H158.836V2.344H153.085V16.519C154.813 16.6 157.918 16.492 159.565 16.087L159.322 13.657ZM168.529 23.188V0.723999H165.64V7.852H163.48V1.048H160.645V22.351H163.48V10.363H165.64V23.188H168.529ZM194.96 10.606V8.041H190.883V0.723999H187.886V23.215H190.883V10.606H194.96ZM172.496 2.317V4.909H180.92C180.569 9.175 177.14 13.387 171.308 15.547L172.982 18.031C180.083 15.169 184.133 9.85 184.133 2.317H172.496ZM213.541 23.62H210.436V20.893H213.541V23.62ZM207.466 7.447C207.466 5.449 208.924 4.018 210.976 4.018C213.028 4.018 214.54 5.449 214.54 7.447C214.54 9.418 213.028 10.876 210.976 10.876C208.924 10.876 207.466 9.418 207.466 7.447ZM216.322 26.077V24.727L217.672 26.401C219.589 25.402 221.155 23.62 221.884 21.811C222.505 23.539 224.26 25.51 225.934 26.266L227.554 24.106C224.854 22.783 223.369 20.218 223.369 17.221V15.466H220.399V17.356C220.399 18.922 219.994 20.299 219.157 21.487C218.428 22.54 217.483 23.377 216.322 23.998V15.52H213.541V18.463H210.436V15.52H207.574V26.077H216.322ZM204.496 7.447C204.496 10.903 207.277 13.468 210.976 13.468C213.811 13.468 216.025 12.01 216.97 9.85C217.159 9.418 217.267 8.986 217.348 8.527H221.992V14.17H224.989V0.669999H221.992V6.016H217.294C217.213 5.719 217.105 5.395 216.97 5.098C215.998 2.911 213.811 1.426 210.976 1.426C207.277 1.426 204.496 4.072 204.496 7.447ZM251.285 15.277V12.739H228.551V15.277H251.285ZM232.385 0.939999V10.039H247.829V7.447H235.409V0.939999H232.385ZM232.25 17.383V25.537H247.802V22.999H235.22V17.383H232.25ZM272.404 3.343V0.778H264.682V3.343H272.404ZM278.911 21.298C278.911 23.026 277.399 24.106 275.158 24.106C272.998 24.106 271.459 23.026 271.459 21.298C271.459 19.57 272.998 18.49 275.158 18.49C277.399 18.49 278.911 19.57 278.911 21.298ZM282.259 15.628V0.643H279.262V8.419H274.996V10.93H279.262V15.628H282.259ZM266.923 7.447C266.869 8.095 266.734 8.662 266.491 9.175C265.573 11.254 263.494 12.496 261.172 13.387L262.576 15.763C265.249 14.98 267.787 12.82 268.624 10.876C269.488 12.793 272.215 14.548 274.591 15.277L275.887 12.847C273.484 12.199 271.486 10.93 270.676 9.013C270.487 8.554 270.352 8.014 270.298 7.447H275.185V4.909H261.874V7.447H266.923ZM281.935 21.298C281.935 18.193 279.127 15.952 275.158 15.952C271.27 15.952 268.435 18.193 268.435 21.298C268.435 24.457 271.27 26.671 275.158 26.671C279.127 26.671 281.935 24.457 281.935 21.298ZM308.528 20.812V18.22H298.646V12.982H295.703V18.22H285.794V20.812H308.528ZM295.433 1.345V2.83C295.433 7.15 291.734 10.228 287.468 11.308L288.872 13.9C292.652 12.658 295.892 10.417 297.161 7.474C298.565 10.39 301.508 12.685 305.477 13.873L306.854 11.281C302.642 10.12 298.889 7.177 298.889 2.83V1.345H295.433ZM333.13 13.009C330.16 11.929 327.325 8.554 327.325 4.774V1.696H324.139V4.828C324.139 8.797 321.574 12.145 318.226 13.819L320.008 16.006C322.681 14.629 324.895 12.172 325.813 9.742C326.731 12.01 329.188 14.413 331.483 15.304L333.13 13.009ZM339.961 25.483V22.891H328V16.654H324.976V25.483H339.961ZM339.502 18.409V0.696999H336.505V6.07H331.429V8.662H336.505V18.409H339.502ZM358.994 7.015H349.814V3.316H358.994V7.015ZM361.991 9.553V0.778H346.817V9.553H361.991ZM362.612 26.455V23.971H349.598V22.324H361.937V15.844H355.889V13.846H365.771V11.308H343.037V13.846H352.946V15.844H346.682V18.328H358.994V19.894H346.682V26.455H362.612Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

const TitleMobileSvg = (
  <svg width="215" height="65" viewBox="0 0 215 65" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M44.6412 8.338C44.6412 6.394 46.0452 4.99 47.9082 4.99C49.8252 4.99 51.3102 6.394 51.3102 8.338C51.3102 10.282 49.8252 11.74 47.9082 11.74C46.0452 11.74 44.6412 10.282 44.6412 8.338ZM62.0562 25.375V22.54H50.2842V16.519H46.9362V25.375H62.0562ZM41.3742 8.365C41.3742 11.875 44.1012 14.548 47.9082 14.548C51.3102 14.548 53.8752 12.496 54.4422 9.634H58.4652V18.382H61.7592V0.831999H58.4652V6.853H54.3882C53.7132 4.126 51.2022 2.128 47.9082 2.128C44.1012 2.128 41.3742 4.882 41.3742 8.365ZM83.1541 23.134H86.3941V0.831999H83.1541V23.134ZM81.3991 22.216V1.156H78.2401V7.582H75.0541V10.309H78.2401V22.216H81.3991ZM76.4041 5.017V2.263H65.1181V5.017H69.1411C69.0871 10.984 67.1701 13.387 64.4161 15.439L66.3871 17.815C68.2501 16.654 70.2751 14.116 70.8691 11.875C71.4901 13.9 73.8391 16.411 75.4051 17.329L77.2951 14.818C74.5951 13.306 72.5431 10.795 72.4621 5.017H76.4041ZM112.703 10.768V8.014H108.68V0.831999H105.386V23.107H108.68V10.768H112.703ZM103.496 12.847C100.283 13.387 96.854 13.792 93.371 13.711V2.128H90.077V16.492C95.585 16.492 100.04 16.222 103.766 15.466L103.496 12.847ZM134.388 22.594C134.388 23.593 133.497 24.403 131.904 24.403C130.311 24.403 129.312 23.593 129.312 22.594C129.312 21.865 130.311 20.947 131.904 20.947C133.497 20.947 134.388 21.838 134.388 22.594ZM135.495 17.194V14.683H128.178V17.194H135.495ZM143.19 13.711V11.092H133.605V8.662H130.284V11.092H120.672V13.711H143.19ZM139.788 3.883V1.237H124.047V3.883H129.636C128.826 5.908 126.153 7.015 123.075 7.447L124.344 10.012C127.638 9.607 130.824 8.149 131.931 5.908C133.173 8.122 136.278 9.472 139.545 9.958L140.814 7.42C137.925 6.988 135.117 5.908 134.226 3.883H139.788ZM137.52 22.783C137.52 22.027 137.196 21.325 136.629 20.704H140.139V18.139H123.723V20.704H127.152C126.558 21.325 126.234 22.027 126.234 22.783C126.234 25.078 128.61 26.779 131.931 26.779C135.171 26.779 137.52 25.078 137.52 22.783ZM160.157 6.61C160.157 8.419 158.51 9.688 156.269 9.688C153.947 9.688 152.381 8.419 152.381 6.61C152.381 4.855 153.974 3.559 156.269 3.559C158.51 3.559 160.157 4.855 160.157 6.61ZM163.397 6.61C163.397 3.046 160.238 0.750998 156.269 0.750998C152.408 0.750998 149.141 3.019 149.141 6.61C149.141 10.552 152.651 12.469 156.269 12.469C159.86 12.469 163.397 10.525 163.397 6.61ZM167.528 16.303V13.522H145.01V16.303H167.528ZM148.736 17.653V25.618H164.207V22.864H152.057V17.653H148.736ZM169.888 22.81H171.67C171.67 23.917 170.86 25.105 169.483 25.375L169.915 26.968C172.318 26.455 173.776 24.403 173.776 22.027V19.165H169.888V22.81ZM5.85836 51.387C5.10236 51.576 3.99536 51.657 3.40136 51.63V43.125H5.69636V40.425H0.269363V54.384C1.94336 54.519 4.72436 54.357 6.04736 54.114L5.85836 51.387ZM13.0404 51.549C12.4464 51.711 11.0964 51.9 10.0974 51.819V43.125H12.7164V40.425H6.99236V54.546C8.58536 54.681 11.7174 54.627 13.3104 54.141L13.0404 51.549ZM22.3554 61.08V38.832H19.2234V45.798H17.3604V39.156H14.2824V60.162H17.3604V48.579H19.2234V61.08H22.3554ZM25.9573 40.371V43.179H34.1383C33.7603 47.094 30.5743 51.198 24.7963 53.331L26.6053 56.031C34.0033 52.98 37.6213 47.634 37.5943 40.371H25.9573ZM48.2323 48.714V45.96H44.2633V38.832H40.9153V61.107H44.2633V48.714H48.2323ZM65.6515 61.242H63.1135V58.893H65.6515V61.242ZM60.1975 45.501C60.1975 43.638 61.5745 42.342 63.4105 42.342C65.2465 42.342 66.6505 43.638 66.6505 45.501C66.6505 47.391 65.2465 48.687 63.4105 48.687C61.5745 48.687 60.1975 47.391 60.1975 45.501ZM68.7565 63.942V62.484L70.1875 64.293C72.0235 63.375 73.5085 61.647 74.1835 59.919C74.8045 61.62 76.5325 63.483 78.0715 64.158L79.8805 61.782C77.0995 60.459 75.8305 57.84 75.8305 55.113V53.412H72.5635V55.302C72.5635 58.002 71.1595 60.351 68.7565 61.593V53.466H65.6515V56.22H63.1135V53.466H60.0085V63.942H68.7565ZM56.9575 45.528C56.9575 48.903 59.6305 51.522 63.4105 51.522C66.7315 51.522 69.2155 49.497 69.7555 46.689H74.0215V52.17H77.3425V38.805H74.0215V43.935H69.6475C68.9455 41.37 66.5695 39.534 63.4105 39.534C59.6305 39.534 56.9575 42.18 56.9575 45.528ZM103.057 53.304V50.496H80.5394V53.304H103.057ZM84.2924 39.048V48.174H99.6554V45.393H87.6134V39.048H84.2924ZM84.1574 55.167V63.429H99.6284V60.648H87.4784V55.167H84.1574ZM123.447 41.586V38.805H115.671V41.586H123.447ZM129.603 59.19C129.603 60.783 128.118 61.782 126.147 61.782C124.122 61.782 122.718 60.783 122.718 59.19C122.718 57.624 124.122 56.625 126.147 56.625C128.118 56.625 129.603 57.624 129.603 59.19ZM133.086 53.79V38.778H129.792V46.365H125.931V49.065H129.792V53.79H133.086ZM126.147 45.69V42.909H112.944V45.69H117.75C117.345 48.579 114.888 50.361 112.242 51.171L113.727 53.79C116.373 52.98 118.83 50.901 119.64 49.065C120.477 50.874 123.231 52.737 125.499 53.277L126.903 50.604C124.095 49.902 121.881 48.444 121.503 45.69H126.147ZM132.87 59.19C132.87 56.085 130.035 53.871 126.147 53.871C122.259 53.871 119.424 56.085 119.424 59.19C119.424 62.403 122.259 64.536 126.147 64.536C130.035 64.536 132.87 62.403 132.87 59.19ZM158.801 58.812V56.058H149.216V50.955H145.895V56.058H136.283V58.812H158.801ZM145.625 39.426V40.911C145.625 45.285 141.926 48.039 137.93 49.119L139.415 51.954C143.114 50.82 146.165 48.633 147.542 45.69C149 48.525 151.889 50.712 155.696 51.9L157.181 49.092C153.239 47.958 149.459 45.285 149.459 40.911V39.426H145.625ZM182.511 50.847C179.649 49.848 176.895 46.419 176.895 42.774V39.75H173.412V42.828C173.412 46.689 170.901 50.064 167.661 51.603L169.605 54.06C172.197 52.845 174.303 50.226 175.221 47.985C176.247 50.145 178.542 52.44 180.783 53.358L182.511 50.847ZM189.315 63.375V60.54H177.624V54.519H174.357V63.375H189.315ZM188.829 56.355V38.832H185.535V44.043H180.81V46.824H185.535V56.355H188.829ZM207.497 44.961H199.073V41.586H207.497V44.961ZM210.818 47.688V38.886H195.752V47.688H210.818ZM211.439 64.347V61.701H198.884V60.324H210.791V53.763H204.959V51.981H214.544V49.254H192.026V51.981H201.638V53.763H195.617V56.436H207.524V57.732H195.617V64.347H211.439Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);
